<div class='container containerUK' *ngIf="object1 | async as item">
    <!-- <p><strong>References:</strong>
        <br><br> -->
    <div class="ref1" [innerHTML]="item.largeparagraphcontent"></div>
    </div>

